import { Box, Typography } from "@mui/material"
import { ReactNode } from "react";

interface PageTitleProps {
  title: string;
  subtitle: ReactNode;
}

const PageTitle: React.FC<PageTitleProps> = ({ title, subtitle }) => {
  return (
    <Box className="X12" py={2}>
      <Typography align='left' variant="h5">{title}</Typography>
      <Typography align='left' variant="body2" color="textSecondary">{subtitle}</Typography>
    </Box>
  )
}

export { PageTitle }